// extracted by mini-css-extract-plugin
export default {"card":"NjoV8","active":"tXUhf","customZip":"HXX5v","ant-btn":"bybrj","antBtn":"bybrj","gridWrapper":"HCO6A","imageWrapper":"s5sej","iconFooter":"zQmjd","deleteButton":"kdSHL"};